import React from "react";
import { Dialog, DialogTitle, DialogContent, Grid, Typography, IconButton, Box, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const EmployeePayrollView = ({ show, handleClose, payroll }) => {
  if (!payroll) return null;

  const {
    emp_id,
    employee_name,
    basic_salary,
    hra,
    bonus,
    deductions,
    month,
    generated_at,
    salary = {},
    challans = [],
    other_allowances,
  } = payroll;

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return date.toLocaleString("default", { month: "long", year: "numeric" });
  };

  const renderTwoColumnList = (obj) => {
    if (!obj || typeof obj !== "object" || Object.keys(obj).length === 0) return "N/A";
    const entries = Object.entries(obj);
    const rows = [];

    for (let i = 0; i < entries.length; i += 2) {
      rows.push(
        <Grid container spacing={2} key={i} sx={{ mb: 1 }}>
          <Grid item xs={6}>
            <strong>{entries[i][0]}:</strong> ₹{entries[i][1] ?? "N/A"}
          </Grid>
          {entries[i + 1] && (
            <Grid item xs={6}>
              <strong>{entries[i + 1][0]}:</strong> ₹{entries[i + 1][1] ?? "N/A"}
            </Grid>
          )}
        </Grid>
      );
    }

    return <>{rows}</>;
  };

  const renderChallans = (challanList) => {
    if (!challanList || !challanList.length) return <div>No challans found.</div>;
    const rows = [];
    for (let i = 0; i < challanList.length; i += 2) {
      rows.push(
        <Grid container spacing={2} key={i} sx={{ mb: 1 }}>
          <Grid item xs={6}>
            <strong>{challanList[i].name}</strong>
          </Grid>
          {challanList[i + 1] && (
            <Grid item xs={6}>
              <strong>{challanList[i + 1].name}</strong>
            </Grid>
          )}
        </Grid>
      );
    }
    return <>{rows}</>;
  };

  const Section = ({ title, children }) => (
    <Box mb={3}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      {children}
    </Box>
  );

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          height: "90vh",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#f9f9f9",
          padding: 2,
        }}
      >
        <Typography variant="h6">Employee Payroll Details</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ overflowY: "auto", padding: 3 }}>
        <Section title="Employee Information">
          <Grid container spacing={2}>
            <Grid item xs={6}><strong>Employee ID:</strong> {emp_id || "N/A"}</Grid>
            <Grid item xs={6}><strong>Employee Name:</strong> {employee_name || "N/A"}</Grid>
          </Grid>
        </Section>

        <Section title="Salary Details">
          <Grid container spacing={2}>
            <Grid item xs={6}><strong>Basic Salary:</strong> ₹{basic_salary ?? "N/A"}</Grid>
            <Grid item xs={6}><strong>HRA:</strong> ₹{hra ?? "N/A"}</Grid>
            <Grid item xs={6}><strong>Bonus:</strong> ₹{bonus ?? "N/A"}</Grid>
            <Grid item xs={6}><strong>Gross Salary:</strong> ₹{salary?.gross_salary?.toFixed(2) ?? "N/A"}</Grid>
            <Grid item xs={6}><strong>Net Salary:</strong> ₹{salary?.net_salary?.toFixed(2) ?? "N/A"}</Grid>
          </Grid>
        </Section>

        <Section title="Challans">
          {renderChallans(challans)}
        </Section>

        <Section title="Other Allowances">
          {renderTwoColumnList(other_allowances)}
        </Section>

        <Section title="Deductions">
          {renderTwoColumnList(deductions)}
        </Section>
      </DialogContent>
    </Dialog>
  );
};

export default EmployeePayrollView;
